import { createConfig, http } from 'wagmi';

import config from '@/config';
import { metaMask, walletConnect, coinbaseWallet } from 'wagmi/connectors';
import {
  baseSepolia,
  arbitrum,
  mainnet,
  base,
  optimism,
  polygon,
  zksync,
  Chain,
} from 'wagmi/chains';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { COLLATERAL_DECIMALS } from '@/store/use-markets-store';
import { bsc } from './chains';

// WalletConnect Project ID
const { WALLET_CONNECT_PROJECT_ID: projectId, isDevelopment } = config;

// Define supported chains
export const chains: readonly [Chain, ...Chain[]] = isDevelopment
  ? [baseSepolia, arbitrum, optimism, bsc]
  : [base, arbitrum, mainnet, optimism, polygon, zksync, bsc];

const transports = Object.fromEntries(
  chains.map((chain) => [
    chain.id,
    chain.id === bsc.id ? http('https://bsc.drpc.org') : http(),
  ]),
);

export const wagmiConfig = createConfig({
  chains: chains,
  connectors: [metaMask(), walletConnect({ projectId }), coinbaseWallet()],
  transports,
});

// Solana Relateds
export const solNetwork = WalletAdapterNetwork.Mainnet;

export const USDC_MINT_ADDRESS = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v';

export const MINT_RECIPIENT = import.meta.env.VITE_BRIDGE_ARBITRUM;

export const SOLANA_CHAIN_ID = 0;

export const getChainDecimals = (chainId: number | undefined) => {
  switch (chainId) {
    case bsc.id:
      return 18n;
    default:
      return COLLATERAL_DECIMALS;
  }
};
